import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { UserManagementService } from 'src/app/user-management/shared/services/user-management.service';
import { SharedDataService } from './shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  @BlockUI() blockUI: NgBlockUI;
  constructor(private _cookieSvc: CookieService, private _toastrSvc: ToastrService) { }
  intercept(httpReq: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //TODO: open Loader here.
    if (this._cookieSvc.get("currentUser")) {
      const authToken = this._cookieSvc.get("currentUser");

      httpReq = httpReq.clone({
        setHeaders: {
          Authorization: authToken,
          'Accept': "application/json",
          "Content-Type": "application/json"
        }
      });
    }
    this.blockUI.start();
    return next.handle(httpReq).pipe(
      //if API fails then again call API 2 time more
      retry(2),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          //TODO:  write code to show error to user
          if (Array.isArray(err.error?.ResultMessages)) {
            if (err.error?.ResultMessages?.length > 0) {
              err.error.ResultMessages.forEach(e => {
                this._toastrSvc.error(e.Message, null, {
                  positionClass: 'toast-bottom-right'
                });
              });
            }
          }

          return throwError(err.error);
        }
      }),
      finalize(() => {
        //TODO: close loader
        this.blockUI.stop();
      })
    );
  }
}
